<template>
    <section>
        <div v-bind="canvasOverlayAttrs" :ref="`overlay-${this.page.pageNumber}`">
            <canvas v-visible.once="drawPage" v-bind="canvasAttrs"></canvas>

            <vue-draggable-resizable
                v-for="(signatureBlock) in signatures"
                v-if="signatureBlock.page_num === page.pageNumber"
                :key="signatureBlock.id"
                :w="calcWidth(signatureBlock.width)"
                :h="calcHeight(signatureBlock.height)"
                :ref="'draggable' + signatureBlock.id"
                :draggable="false"
                :resizable="false"
                :parent="true"
                :style="`position: absolute; top: ${calcTop(signatureBlock.y)}%; left: ${calcLeft(signatureBlock.x)}%;`">
                <div class="mask" @click="$bus.$emit('openPad', signatureBlock)">
                    <div v-if="!checkIfSigned(signatureBlock)" class="maskActive col-12 d-none d-md-flex flex-md-row justify-content-md-between align-items-md-center" >
                        <i class="fas fa-pen-nib fa-2x text-white mr-3"></i>
                        <p><strong>Click to Sign</strong></p>
                    </div>
                    <img
                        v-else
                        :src="customerSignature.temporary_url"
                        style="width: 100%; height: auto;"
                    />
                </div>
          </vue-draggable-resizable>
      </div>
    </section>
</template>

<script>
import visible from '@shared/components/pdf/directives/visible';
import { mapGetters } from "vuex";

export default {
  name: 'PDFPageSingle',
  components: {
  },

  props: {
    page: {
      required: true,
    },
    currentPage: {
      type: Number
    },
    signatures: {
      required: false,
    },
    unsignedBlocks:{
      required: false
    }
  },
  data() {
    return {
      renderTask: undefined
    }
  },

  directives: {
    visible,
  },

  computed: {
    ...mapGetters({
      customerSignature: "signature/getCustomerSignature"
    }),

    canvasStyle() {
      return `width: 100%!important; height: auto!important; max-width: none!important;`;
    },

    canvasOverlayAttrs() {
      const pageW = _.get(this.page, 'view.2', 1590);
      const pageH = _.get(this.page, 'view.3', 2249);
      const width = pageW > pageH ? 2249 : 1590;
      const height = pageW > pageH ? 1590 : 2249;
      const style = `position: relative`;
      return {
        width,
        height,
        style,
        class: `overlay`,
      };
    },

    canvasAttrs() {
      const pageW = _.get(this.page, 'view.2', 1590);
      const pageH = _.get(this.page, 'view.3', 2249);
      const style = this.canvasStyle;
      const width = pageW > pageH ? 2249 : 1590;
      const height = pageW > pageH ? 1590 : 2249;

      return {
        width,
        height,
        style,
        class: 'pdf-page box-shadow',
      };
    },

    pageNumber() {
      return this.page.pageNumber;
    },
  },

  methods: {
    checkIfSigned(block) {
        return _.isUndefined(this.unsignedBlocks.find(item => item.id == block.id));
    },
    drawPage() {
      if (this.renderTask) return;
      const viewport = this.page.getViewport(2.67);
      const canvasContext = this.$el.querySelector('canvas').getContext('2d');
      const renderContext = {canvasContext, viewport};
      this.renderTask = this.page.render(renderContext);
      this.renderTask
        .then(() => {
          this.$bus.$emit('pdf::page::rendered', {
            page: this.page,
            text: `Rendered page ${this.pageNumber}`,
          });
         })
        .catch(response => {
          this.destroyRenderTask();
          this.$bus.$emit('pdf::page::errored', {
            response,
            page: this.page,
            text: `Failed to render page ${this.pageNumber}`,
          });
        });
    },

    destroyPage(page) {
      if (page) page._destroy();

      this.destroyRenderTask();
    },

    destroyRenderTask() {
      if (!this.renderTask) return;
      this.renderTask.cancel();
      delete this.renderTask;
    },

    calcLeft(x) {
      const parentWidth = _.get(this.page, 'view.2', 1190);
      const parentHeight = _.get(this.page, 'view.3', 1684);
      const w = parentWidth > parentHeight ? 1684 : 1190;
      let percent = (x/w) * 100;

      return percent;
    },

    calcTop(y) {
      const parentWidth = _.get(this.page, 'view.2', 1190);
      const parentHeight = _.get(this.page, 'view.3', 1684);
      const h = parentWidth > parentHeight ? 1190 : 1684;
      let percent = (y/h) * 100;

      return percent;
    },

    calcHeight(y) {
      let parentWidth = _.get(this.page, 'view.2', 1190);
      let parentHeight = _.get(this.page, 'view.3', 1684);
      let h = parentWidth > parentHeight ? 1190 : 1684;

      let percent = (y/h) * 100;

      return percent;
    },

    calcWidth(x) {
      let parentWidth = _.get(this.page, 'view.2', 1190);
      let parentHeight = _.get(this.page, 'view.3', 1684);
      let w = parentWidth > parentHeight ? 1684 : 1190;

      let percent = (x/w) * 100;
      let overlayWidth = $('#entryStatement').width() - 30;

      return overlayWidth*(percent/100);
    },
  }
};
</script>
<style lang="scss">
 .maskActive {
    p {
        font-size: 1.2em!important;
        margin: 0;
        padding: 0.5em;
        color: #fff;
    }
 }
 .pdf-page {
    display: block;
    margin: 0 auto;
    border: 1px solid #d0d0d0;
    -webkit-box-shadow: 0 0 25px -15px;
    box-shadow: 0 0 25px -15px;
  }
</style>
